import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5d9e6656")

_pushScopeId("data-v-5d9e6656")
const _hoisted_1 = { class: "OrdersList" }
const _hoisted_2 = { class: "OrdersList__header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { class: "title" }, "Мои заказы", -1)
const _hoisted_4 = { class: "OrdersList__list scroll green" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"list__header\" data-v-5d9e6656><div class=\"list__row header\" data-v-5d9e6656><div class=\"list__col first header\" data-v-5d9e6656>Заказ</div><div class=\"list__col second header\" data-v-5d9e6656>Дата создания</div><div class=\"list__col third header\" data-v-5d9e6656>Количество накладных</div><div class=\"list__col fourth header\" data-v-5d9e6656></div></div></div>", 1)
const _hoisted_6 = { class: "list__body" }
const _hoisted_7 = { class: "list__col first col-big" }
const _hoisted_8 = { class: "list__col second" }
const _hoisted_9 = { class: "list__col third" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Подробнее ")
const _hoisted_11 = {
  key: 1,
  class: "OrdersList__loading"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_refresh = _resolveComponent("icon-refresh")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_s_loader = _resolveComponent("s-loader")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_icon_refresh, {
        class: "header__refresh",
        onClick: _ctx.emitRefresh
      }, null, 8, ["onClick"])
    ]),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orders, (order, i) => {
                return (_openBlock(), _createBlock("div", {
                  class: "list__row",
                  key: `OrdersList-order-${i}`
                }, [
                  _createVNode("div", _hoisted_7, _toDisplayString(order.id), 1),
                  _createVNode("div", _hoisted_8, _toDisplayString(order.created_at), 1),
                  _createVNode("div", _hoisted_9, _toDisplayString(order.invoices_count) + " " + _toDisplayString(_ctx.declOfNum(order.invoices_count, _ctx.INVOICES_TOKENS)), 1),
                  _createVNode(_component_router_link, {
                    to: `/order/ltl/${order.id}`,
                    class: "list__col fourth col-shadow"
                  }, {
                    default: _withId(() => [
                      _hoisted_10
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ])
          ]),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 64))
      : (_openBlock(), _createBlock("div", _hoisted_11, [
          _createVNode(_component_s_loader)
        ]))
  ]))
})